import { Box, IconButton, Tooltip, Typography } from '@mui/material';
import CloseOutlined from '@mui/icons-material/CloseOutlined';
import LinkedIn from '@mui/icons-material/LinkedIn';
import React from 'react';
import { updateObjectStateValue } from '../../../../utils/FunctionHelpers';
import { commonGridSx, gridLocaleText, makeGridToolbar } from '../../../../utils/gridStyles';
import { DataGrid } from '../../../../components/SortableDataGrid/SortableDataGrid';

const CustomToolbar = makeGridToolbar('Contacts à importer');

const Step3 = ({ importData, setImportData }) => {
  const handleDeleteContact = (rowIdx) => {
    const tmp = [...importData.contactsToImport];
    tmp.splice(rowIdx, 1);
    updateObjectStateValue(setImportData, { contactsToImport: tmp });
  };

  const columns = [
    {
      field: 'titre', headerName: 'TITRE', width: 80,
      renderCell: (p) => <Typography sx={{ fontSize: '1rem', color: '#475569' }}>{p.value || '—'}</Typography>,
    },
    {
      field: 'prenom', headerName: 'PRÉNOM', width: 130,
      renderCell: (p) => (
        <Typography sx={{ fontSize: '1rem', color: '#475569', textTransform: 'capitalize', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {p.value || '—'}
        </Typography>
      ),
    },
    {
      field: 'nom', headerName: 'NOM', width: 130,
      renderCell: (p) => (
        <Typography sx={{ fontSize: '1rem', fontWeight: 600, color: '#0f172a', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {p.value || '—'}
        </Typography>
      ),
    },
    {
      field: 'fonction', headerName: 'FONCTION', flex: 1, minWidth: 180,
      renderCell: (p) => (
        <Typography sx={{ fontSize: '1rem', color: '#475569', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {p.value || '—'}
        </Typography>
      ),
    },
    {
      field: 'mobile', headerName: 'MOBILE', width: 130,
      renderCell: (p) => <Typography sx={{ fontSize: '1rem', color: '#475569' }}>{p.value ?? '—'}</Typography>,
    },
    {
      field: 'email', headerName: 'EMAIL', width: 180,
      renderCell: (p) => (
        <Typography sx={{ fontSize: '1rem', color: '#475569', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>
          {p.value || '—'}
        </Typography>
      ),
    },
    {
      field: 'linkedIn', headerName: 'LINKEDIN', width: 80, align: 'center', headerAlign: 'center', sortable: false,
      renderCell: (p) => p.value ? (
        <a href={p.value} target="_blank" rel="noreferrer" style={{ color: '#0a66c2', lineHeight: 0 }}>
          <LinkedIn sx={{ fontSize: 20 }} />
        </a>
      ) : <Typography sx={{ color: '#cbd5e1', fontSize: '1rem' }}>—</Typography>,
    },
    {
      field: '_actions', headerName: '', width: 60, sortable: false, filterable: false,
      renderCell: (p) => (
        <Tooltip title="Supprimer">
          <IconButton size="small" onClick={() => handleDeleteContact(p.row._rowIdx)}>
            <CloseOutlined color="error" sx={{ fontSize: 16 }} />
          </IconButton>
        </Tooltip>
      ),
    },
  ];

  const rows = (importData.contactsToImport || []).map((c, i) => ({ ...c, id: i, _rowIdx: i }));

  return (
    <Box sx={{ height: '500px', borderRadius: 3, border: '1px solid #e2e8f0', overflow: 'hidden', display: 'flex', flexDirection: 'column', background: '#fff' }}>
      <DataGrid
        rows={rows}
        columns={columns}
        getRowId={(row) => row.id}
        pageSizeOptions={[50, 100]}
        disableRowSelectionOnClick
        showToolbar
        slots={{ toolbar: CustomToolbar }}
        slotProps={{ loadingOverlay: { variant: 'skeleton', noRowsVariant: 'skeleton' } }}
        localeText={gridLocaleText}
        sx={commonGridSx}
      />
    </Box>
  );
};

export default Step3;
